<div class="loading-dialog flex flex-col p-2">
    <div class="loading-bar-message md:text-sm">
        <span>{{ shownMessage }}</span>
    </div>
    <mat-progress-bar class="loading-bar" mode="indeterminate"> </mat-progress-bar>
</div>
